import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

const BTN = "border border-[#2E2E2A] px-3 py-1.5 text-xs uppercase tracking-[0.1em] text-[#A3A39C] transition-colors duration-200 hover:border-[#C49A6C] hover:text-[#C49A6C]";

export const RichEmailEditor = ({ onChange, initialHtml = "", testid = "rich-editor" }) => {
  const ref = useRef(null);
  const fileRef = useRef(null);

  useEffect(() => {
    if (initialHtml && ref.current) ref.current.innerHTML = initialHtml;
  }, []);

  const sync = () => onChange(ref.current.innerHTML);

  const exec = (cmd, arg = null) => {
    ref.current.focus();
    document.execCommand(cmd, false, arg);
    sync();
  };

  const addLink = () => {
    const text = window.prompt("Link text (what readers see)", "Click here");
    if (!text) return;
    const url = window.prompt("Link URL (https://...)", "https://www.toptailoredproperties.com");
    if (!url) return;
    ref.current.focus();
    document.execCommand(
      "insertHTML",
      false,
      `<a href="${url}" style="color:#A67C52;text-decoration:underline">${text}</a>&nbsp;`
    );
    sync();
  };

  const addButton = () => {
    const label = window.prompt("Button text", "Book a Call");
    if (!label) return;
    const url = window.prompt("Button links to", "https://www.toptailoredproperties.com/services");
    if (!url) return;
    ref.current.focus();
    document.execCommand(
      "insertHTML",
      false,
      `<a href="${url}" style="display:inline-block;background:#C49A6C;color:#141413;padding:12px 26px;text-decoration:none;font-size:12px;letter-spacing:2px;text-transform:uppercase;font-weight:bold">${label}</a>&nbsp;`
    );
    sync();
  };

  const uploadImage = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    try {
      const r = await api.post("/admin/newsletter/upload-image", fd);
      ref.current.focus();
      document.execCommand(
        "insertHTML",
        false,
        `<img src="${r.data.url}" alt="" style="max-width:100%;height:auto;display:block;margin:16px 0" />`
      );
      sync();
      toast.success("Image added to your newsletter.");
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <div>
      <div className="mb-2 flex flex-wrap gap-2" data-testid={`${testid}-toolbar`}>
        <button type="button" className={BTN} onClick={() => exec("bold")} data-testid={`${testid}-bold`}><strong>B</strong></button>
        <button type="button" className={BTN} onClick={() => exec("italic")} data-testid={`${testid}-italic`}><em>I</em></button>
        <button type="button" className={BTN} onClick={() => exec("underline")} data-testid={`${testid}-underline`}><u>U</u></button>
        <button type="button" className={BTN} onClick={() => exec("formatBlock", "h2")} data-testid={`${testid}-heading`}>Heading</button>
        <button type="button" className={BTN} onClick={() => exec("foreColor", "#A67C52")} data-testid={`${testid}-gold`}>Gold</button>
        <button type="button" className={BTN} onClick={addLink} data-testid={`${testid}-link`}>Link</button>
        <button type="button" className={BTN} onClick={addButton} data-testid={`${testid}-cta`}>Button</button>
        <button type="button" className={BTN} onClick={() => fileRef.current.click()} data-testid={`${testid}-image`}>Image / Flyer</button>
      </div>
      <div
        ref={ref}
        contentEditable
        data-testid={testid}
        onInput={sync}
        className="min-h-[220px] rounded-none border border-[#2E2E2A] bg-[#141413] p-4 text-[#F4F4F0] outline-none transition-colors duration-200 focus:border-[#C49A6C]"
        style={{ lineHeight: 1.7 }}
      />
      <input ref={fileRef} type="file" accept="image/png,image/jpeg,image/webp,image/gif" className="hidden" onChange={uploadImage} data-testid={`${testid}-image-input`} />
      <p className="mt-2 text-xs text-[#A3A39C]">Tip: upload your flyer as an image, add a heading, and finish with a button linking to your site.</p>
    </div>
  );
};
